import React, {useEffect, useState} from 'react';
import {
    Alert,
    Button, Card,
    Cascader,
    Col,
    ConfigProvider,
    DatePicker,
    DatePickerProps,
    Divider,
    Form,
    Input,
    InputNumber, List,
    Modal,
    Row,
    Select,
    Switch,
    Tag, Tooltip
} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {GetInscripcionsActivitats} from "../../../dao/inscripcions/GetInscripcionsActivitats";
import 'dayjs/locale/es';
import locale from "antd/es/locale/es_ES";
import dayjs, {Dayjs} from "dayjs";
import Activitat from "../../../model/inscripcions/Activitat";
import {Tabs} from "antd-v5";
import Torn from "../../../model/inscripcions/Torn";
import {GetInscripcionsActivitatIdTorn} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdTorn";
import {ColumnsType, TableProps} from "antd/es/table";
import Contacte from "../../../model/inscripcions/Contacte";
import {Escola} from "../../../model/root/Escola";
import {GetInscripcionsEscoles} from "../../../dao/inscripcions/GetInscripcionsEscoles";
import AlumneCasal from "../../../model/inscripcions/AlumneCasal";
import {GetInscripcionsIdInfants} from "../../../dao/inscripcions/GetInscripcionsIdInfants";
import {useParams} from "react-router-dom";
import {PostInscripcioInscripcio} from "../../../dao/inscripcions/PostInscripcioInscripcio";
import Alergen from "../../../model/inscripcions/Alergen";
import {GetAlergens} from "../../../dao/inscripcions/GetAlergens";
import {GetInscripcionsActivitatIdExtres} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdExtres";
import Extra from "../../../model/inscripcions/Extra";
import TextArea from "antd/es/input/TextArea";
import toast, {Toaster} from "react-hot-toast";

interface PagadorModalProps {
    element: any; // Cambiado a tipo any para aceptar cualquier tipo de elemento
    visible: boolean;
    page: string;
    onClose: (value: boolean) => void;
    edit: boolean;
}

const InscripcioModal: React.FC<PagadorModalProps> = ({element, visible, onClose, page, edit}) => {
    const [form] = Form.useForm();
    const {id_inscripcio} = useParams();
    const [options, setOptions] = useState<Activitat[]>([]);
    const [infants, setInfants] = useState<AlumneCasal[]>([]);
    const [alergens, setAlergens] = useState<Alergen[]>([]);
    const [torns, setTorns] = useState<Torn[]>([]);
    const [extres, setExtres] = useState<Extra[]>([]);
    const [escoles, setEscoles] = useState<Escola[]>([]);
    const [disabled, setDisabled] = useState(true);
    const [isSend, setIsSend] = useState(false);
    const [setmanesDisabled, setSetmanesDisabled] = useState<boolean>();
    const [texte, setTexte] = useState("Carregant dades...");
    const [inici, setInici] = useState("");
    const [fin, setFin] = useState("");
    const [activitat, setActivitat] = useState(0);
    const [rangePresets, setRangePresets] = useState<any>([]);
    const [casal, setCasal] = useState(0);
    const [campus, setCampus] = useState(0);
    const [entrada, setEntrada] = useState(0);
    const [tipus, setTipus] = useState(0);
    const [idIns, setIdIns] = useState("0");
    const [activitats, setActivitats] = useState<(string | number)[]>([0, 0, 0]);
    const [setmanes, setSetmanes] = useState([{}]);

    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setSetmanesDisabled(activitat === 0);
        //console.log(JSON.stringify(element));
        checkOptions();
    }, []);

    async function checkOptions() {
        setIsSend(true);
        setDisabled(true);
        var idInsc = id_inscripcio;
        if (idInsc === undefined) {
            idInsc = element.id_inscripcio;
        }
        setIdIns(idInsc+"");
        setSetmanesDisabled(true);
        setTexte("Carregant dades...");
        const dades = await GetInscripcionsActivitats(page);
        const esc = await GetInscripcionsEscoles(page);
        const inf = await GetInscripcionsIdInfants(idInsc + "", page);
        const ale = await GetAlergens(page);
        //console.log(">>>>"+JSON.stringify(esc));
        setEscoles(esc);
        setInfants(inf);
        setAlergens(ale);
        setOptions(dades.activitat);

        if ((casal !== null && casal !== 0)) {
            checkTorns(casal);
        } else if (element.activitat && element.activitat[1] !== undefined && element.activitat[3] !== undefined) {
            //checkTorns(element.activitat[1]);

            const activitatObj = dades.activitat.find((option : any) => option.id === element.activitat[0]);

            if (activitatObj) {
                setDisabled(true);

                const casalObj = activitatObj.children.find((casal : any) => casal.id === element.activitat[1]);

                if (casalObj) {
                    const inici = casalObj.inici;
                    const fin = casalObj.fin;
                    setFin(fin + "");
                    setInici(inici + "");
                    checkTorns(element.activitat[1]);
                }
            }
        }

        setTexte("Selecciona activitat");
        setSetmanesDisabled(activitat === 0);
        setDisabled(false);
        setIsSend(false);
    }

    async function checkTorns(casal: number) {
        setIsSend(true);
        const trn = await GetInscripcionsActivitatIdTorn(casal, page);
        const ext = await GetInscripcionsActivitatIdExtres(casal, page);
        setTorns(trn);
        setExtres(ext);
        setSetmanesDisabled(false);
        setIsSend(false);
        //console.log("TORNS:"+JSON.stringify(trn));
    }

    async function handleSubmit() {
        setIsSend(true);
        const formData = form.getFieldsValue();

        console.log("Form Data:", formData);

        const inscripcionsArray: any[] = [];
        const extrasArray: any[] = [];

        for (const key in formData) {
            if (formData.hasOwnProperty(key)) {
                if (key.startsWith('setmanes-') || key.startsWith('dies-')) {
                    const index = parseInt(key.split('-')[1]); // Obtenemos el índice del setmanes o dies
                    const id_torn = torns[index].id; // Obtenemos el id_torn correspondiente del array torns
                    let idExist = inscripcionsArray.findIndex(ins => ins.id_torn === id_torn);
                    if (idExist === -1) {
                        const newData = {
                            id_torn: id_torn,
                            setmanes: [],
                            dies: []
                        };
                        inscripcionsArray.push(newData);
                        idExist = inscripcionsArray.length - 1; // Actualizamos idExist después de agregar un nuevo elemento
                    }
                    if (key.startsWith('setmanes-')) {
                        if (formData[key] !== undefined) inscripcionsArray[idExist].setmanes = formData[key];
                        else inscripcionsArray[idExist].setmanes = [];
                    } else {
                        if (formData[key] !== undefined) inscripcionsArray[idExist].dies = formData[key];
                        else inscripcionsArray[idExist].dies = [];
                    }
                    delete formData[key];
                }
                if (key.startsWith('extra-')) {
                    const index = parseInt(key.split('-')[1]); // Obtenemos el índice del setmanes o dies
                    const id_extra = extres[index].id; // Obtenemos el id_torn correspondiente del array torns
                    let idExist = extrasArray.findIndex(ins => ins.id_extra === id_extra);
                    if (idExist === -1) {
                        const newData = {
                            id: id_extra,
                            valor: formData[key]?.toString()
                        };
                        if (formData[key] !== undefined)
                            extrasArray.push(newData);
                    }
                    delete formData[key];
                }
            }
        }

        // Asignamos los nuevos arrays al formData
        formData['configuracions'] = inscripcionsArray;
        formData['extras'] = extrasArray;

        const newData = {
            ...formData,
            id_activitat: formData.activitat[0],
            id_casal: formData.activitat[1],
            id_campus: formData.activitat[2],
            id_escola_entrada: formData.activitat[3],
            curs: formData.curs[1],
            cicle: formData.curs[0],
            id: element.id_alumne_casal
        };
        delete newData['activitat'];

        for (const key in newData) {
            if (key === 'configuracions') {
                const hasData = newData.configuracions.some((config: any) => {
                    //console.log("dies: " + JSON.stringify(config.dies) + " setmanes: " + config.setmanes.length);
                    return config.dies.length > 0 || config.setmanes.length > 0;
                });
                //console.log("TAMA: " + hasData);
                if (hasData) {

                    //console.log(convertirJSON(newData));
                    //console.log("Form Data con setmanes reorganizados:", newData);
                    console.log(JSON.stringify(newData));
                    await PostInscripcioInscripcio(idIns, page, newData);
                    onClose(true);
                } else {
                    toast.error("Cal sel·leccionar els dies de casal!");
                }
            }
        }
        setIsSend(false);
    };


    const onChangeWeek: DatePickerProps<Dayjs[]>['onChange'] = (date, dateString) => {
        //console.log(dateString);
        const newSetmanes = [...setmanes, {"setmana": dateString, "tipus": tipus}];
        //console.log(JSON.stringify(newSetmanes));
        setSetmanes(newSetmanes);

    };

    const handleCancel = () => {
        onClose(false);
    };

    const onChange = (value: (string | number)[]) => {
        //console.log(value);
        setSetmanesDisabled(true);
        setDisabled(true)
        setActivitats(value);
        const act = parseInt(value[0] + "");
        setActivitat(act);
        const cas = parseInt(value[1] + "");
        setCasal(cas);
        const camp = parseInt(value[2] + "");
        setCampus(camp);
        const ent = parseInt(value[3] + "");
        setEntrada(ent);

        const activitatObj = options.find((option) => option.id === act);

        if (activitatObj) {
            setDisabled(true)
            const casalObj = activitatObj.children.find((casal) => casal.id === cas);

            if (casalObj) {
                // Acceder a los valores de inici y fin del casalObj
                const inici = casalObj.inici;
                const fin = casalObj.fin;

                setRangePresets(generarRangePresets(inici, fin));
                setFin(fin + "");
                setInici(inici + "");
                checkTorns(cas);
            } else {
                //console.log('Casal no encontrado');
            }
        } else {
            //console.log('Activitat no encontrada');
        }

        setDisabled(false);
    };


    const dropdownRender = (menus: React.ReactNode) => (
        <div>
            {menus}
            <Divider style={{margin: 0}}/>
            <div style={{backgroundColor: Colors.colors.color6}}>
                <b>Selecciona: </b>Activitat / Casal / Campus / Escola d'entrada
            </div>
        </div>
    );

    const {RangePicker} = DatePicker;

    const dateFormatEn = 'YYYY-MM-DD';
    const dateFormatEs = 'DD-MM-YYYY';
    const weekFormat = 'DD/MM';

    const customWeekStartEndFormat: DatePickerProps['format'] = (value) =>
        `${dayjs(value).startOf('week').format(weekFormat)} ~ ${dayjs(value)
            .endOf('week')
            .format(weekFormat)}`;

    const customWeekStartEndFormatDay: DatePickerProps['format'] = (value) =>
        `${dayjs(value).startOf('day').format(weekFormat)}`;

    const customWeekStartEndFormatDayA: DatePickerProps['format'] = (value) =>
        `${dayjs(value).format(dateFormatEs)}`;

    interface Option {
        value: string | number;
        label: string;
        children?: Option[];
    }

    const cursos: Option[] = [
        {
            value: 'infantil',
            label: 'Educació Infantil',
            children: [
                {
                    value: 'I3',
                    label: 'Infantil 3 anys',
                },
                {
                    value: 'I4',
                    label: 'Infantil 4 anys',
                },
                {
                    value: 'I5',
                    label: 'Infantil 5 anys',
                },
            ],
        },
        {
            value: 'primaria',
            label: 'Educació Primària',
            children: [
                {
                    value: '1o',
                    label: '1r de Primària',
                },
                {
                    value: '2o',
                    label: '2n de Primària',
                },
                {
                    value: '3o',
                    label: '3r de Primària',
                },
                {
                    value: '4o',
                    label: '4t de Primària',
                },
                {
                    value: '5o',
                    label: '5è de Primària',
                },
                {
                    value: '6o',
                    label: '6è de Primària',
                },
            ],
        },
        {
            value: 'secundaria',
            label: 'Educació Secundària Obligatòria (ESO)',
            children: [
                {
                    value: '1ESO',
                    label: '1r d\'ESO',
                },
                {
                    value: '2ESO',
                    label: '2n d\'ESO',
                },
                {
                    value: '3ESO',
                    label: '3r d\'ESO',
                },
                {
                    value: '4ESO',
                    label: '4t d\'ESO',
                },
            ],
        },
        {
            value: 'batxillerat',
            label: 'Batxillerat',
            children: [
                {
                    value: '1BATX',
                    label: '1r de Batxillerat',
                },
                {
                    value: '2BATX',
                    label: '2n de Batxillerat',
                },
            ],
        },
        // Puedes agregar más niveles educativos según tus necesidades
    ];


    /*const rangePresets = [
        {label: 'Setmana 1', value: () => (dayjs(inici).add(0, 'w'))},
        {label: 'Setmana 2', value: dayjs(inici).add(1, 'w')},
        {label: 'Setmana 3', value: dayjs(inici).add(2, 'w')},
        {label: 'Setmana 4', value: dayjs(inici).add(3, 'w')},
        {label: 'Setmana 5', value: dayjs(inici).add(4, 'w')},
        {label: 'Setmana 6', value: dayjs(inici).add(5, 'w')}
    ];*/

    const generarRangePresets = (inici: any, fin: any) => {
        const start = dayjs(inici);
        const end = dayjs(fin);
        const numWeeks = end.diff(start, 'week') + 1; // +1 para incluir la última semana
        const presets = [];

        for (let i = 0; i < numWeeks; i++) {
            presets.push({
                label: `Setmana ${i + 1}`,
                value: dayjs(inici).add(i, 'week'),
            });
        }

        return presets;
    };

    const style: React.CSSProperties = {
        border: `1px solid green`,
        borderRadius: '50%',
    };
    const cellRender: DatePickerProps<Dayjs>['cellRender'] = (current, info) => {

        if (info.type !== 'week') {
            return info.originNode;
        }

        if (typeof current === 'number' || typeof current === 'string') {
            return <div className="ant-picker-cell-inner">{current}</div>;
        }
        return (
            <div className="ant-picker-cell-inner" style={current.date() === 1 ? style : {}}>
                {current.date()}
            </div>
        );
    };

    const valors = ["Matí", "Matí i Tarda", "Menjador", "Acollida"];

    const getCurrentAnchor = () => '#components-anchor-demo-static';

    const tableProps: TableProps<Contacte> = {
        loading
    };


    const columns: ColumnsType<Contacte> = [
        {
            key: 'document',
            title: 'Documentació',
            dataIndex: 'document',
            width: 30,
        },
        {
            key: 'descarrega',
            title: 'Descarregar',
            dataIndex: 'descarrega',
            width: 30,
            render: (estat, ele) => (
                <>{ele.quota}{"%"}</>
            ),
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 30,
            render: (estat, ele) => (
                <>
                    <Tag color={ele.estat === 1 ? "success" : "warning"}>{ele.estat === 1 ? "ACTIU" : "NO ACTIU"}</Tag>
                </>
            ),
        },
        {
            key: 'pujar', title: 'Documentació signada', dataIndex: 'pujar', width: 30,
            render: (estat, ele) => (
                <>
                </>
            ),
        },
    ];

    const talles = [
        {label: "Samarreta Talla 4-5", value: "4-5"},
        {label: "Samarreta Talla 6-8", value: "6-8"},
        {label: "Samarreta Talla 9-10", value: "9-10"},
        {label: "Samarreta Talla 11-12", value: "11-12"},
        {label: "Samarreta Talla 13-14", value: "13-14"},
        {label: "Samarreta Talla 15-16", value: "15-16"}
    ];


    const onChangeTable: TableProps<Contacte>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            ///console.log('params', pagination, filters, sorter, extra);
        };

    let onChangeCurso;
    return (
        <ConfigProvider locale={locale}>
            <Toaster/>
            <Modal
                title="INSCRIPCIÓ"
                visible={visible}
                onCancel={handleCancel}
                footer={[]}
                maskClosable={false}
                width={"80%"}
            >
                <Form form={form} initialValues={element} onFinish={handleSubmit}>
                    <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <Form.Item label="Selecciona Infant" name="infant"
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Select showSearch
                                        disabled={infants.length === 0 || edit}
                                        placeholder="Selecciona Infant"
                                        optionFilterProp="children"
                                        options={infants}
                                />
                            </Form.Item>
                            <Form.Item label="Escola habitual" name="escola"
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Select showSearch
                                        placeholder="Selecciona Escola"
                                        disabled={escoles.length === 0}
                                        optionFilterProp="children"
                                        options={escoles}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Curs" name="curs"
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Cascader options={cursos} onChange={onChangeCurso} placeholder="Selecciona cicle"/>
                            </Form.Item>
                            <Form.Item label="ID" name="id_alumne_casal">
                                <Input disabled/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[32, 32]}>
                        <Col span={24}>
                            <Form.Item label="Alergens" name="alergens">
                                <Select
                                    disabled={alergens.length === 0}
                                    mode="multiple"
                                    style={{width: '100%'}}
                                    options={alergens}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[32, 32]}>
                        <Col span={24}>
                            <Form.Item label="Observacions" name="observacions">
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <br/>
                    <h6>Selecció d'activitat i casal:</h6>
                    <hr/>
                    <Row gutter={[32, 32]}>
                        <Col span={24}>
                            <Form.Item label="Activitat" name="activitat"
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Cascader options={options} onChange={onChange}
                                          placement={"bottomLeft"}
                                          dropdownRender={dropdownRender}
                                          placeholder={texte} disabled={disabled}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Alert
                        message={"Selecciona el torn i les setmanes / dies exporàdics de cada torn. Podeu fer convinacions com vulgueu!"}
                        type={"success"}/>
                    <br/>

                    <Card type="inner">
                        <List
                            itemLayout="horizontal"
                            dataSource={torns}
                            renderItem={(torn, index) => (
                                <List.Item
                                    hidden={setmanesDisabled}>
                                    <List.Item.Meta
                                        title={<a>{torn.nom}</a>}
                                        description={
                                            <>
                                                <Alert type={"info"} message={torn.descripcio}/>
                                                <br/>
                                                {(torn.tipus === 'noexporaidics' || torn.tipus === 'tot') && (
                                                    <Form.Item
                                                        label="Setmanes senceres"
                                                        name={`setmanes-${index}`}
                                                    >
                                                        <DatePicker
                                                            multiple
                                                            onChange={onChangeWeek}
                                                            minDate={dayjs(inici, dateFormatEn)}
                                                            maxDate={dayjs(fin, dateFormatEn)}
                                                            disabled={setmanesDisabled}
                                                            format={customWeekStartEndFormat}
                                                            picker="week"
                                                            cellRender={cellRender}
                                                            presets={rangePresets}
                                                        />
                                                    </Form.Item>
                                                )}
                                                {(torn.tipus === 'exporadics' || torn.tipus === 'tot') && (
                                                    <Form.Item label="Dies exporàdics" name={`dies-${index}`}>
                                                        <DatePicker
                                                            multiple
                                                            onChange={onChangeWeek}
                                                            minDate={dayjs(inici, dateFormatEn)}
                                                            maxDate={dayjs(fin, dateFormatEn)}
                                                            disabled={setmanesDisabled}
                                                            format={customWeekStartEndFormatDay}
                                                            picker={"date"}
                                                        />
                                                    </Form.Item>
                                                )}
                                            </>
                                        }
                                    />
                                </List.Item>
                            )}
                        />
                    </Card>
                    {extres.length > 0 && (
                        <>
                            <br/>
                            <h6>Opcions Extres</h6>
                            <hr/>
                            <Card type="inner">
                            <List
                                itemLayout="horizontal"
                                dataSource={extres}
                                renderItem={(extra, index) => (
                                    <List.Item
                                        hidden={setmanesDisabled}>
                                        <List.Item.Meta
                                            title={<a>{extra.nom}</a>}
                                            description={
                                                <>
                                                    <Alert type={"warning"} message={extra.descripcio}/>
                                                    <br/>
                                                    {(extra.tipus === 'checkbox') && (
                                                        <Form.Item label="SI / NO" name={`extra-${index}`}>
                                                            <Switch defaultChecked={false} />
                                                        </Form.Item>
                                                    )}
                                                    {(extra.tipus === 'number') && (
                                                        <Form.Item label="Quantitat desitjada" name={`extra-${index}`}>
                                                            <InputNumber/>
                                                        </Form.Item>
                                                    )}
                                                    {(extra.tipus === 'select') && (
                                                        <Form.Item label="Talla desitjada" name={`extra-${index}`}>
                                                            <Select showSearch
                                                                    placeholder="Selecciona Talla"
                                                                    optionFilterProp="children"
                                                                    options={talles}
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </>
                                            }
                                        />
                                    </List.Item>
                                )}
                            />
                            </Card>
                        </>
                    )}
                    <br/>
                    <Row gutter={[32, 32]}>
                        <Col span={24}>
                            <Form.Item label="Comentaris" name="comentaris">
                                <TextArea/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={4}>
                            <Form.Item wrapperCol={{offset: 0, span: 16}}>
                                <Button title={"Documentació"} htmlType={"submit"} disabled={isSend}
                                        style={{backgroundColor: Colors.colors.color6}}><BiCheck/> GUARDAR </Button>
                            </Form.Item>
                        </Col>
                        <Col span={1}>
                        </Col>
                        <Col span={2}>
                            <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color3}}
                                    onClick={handleCancel}><BiX/> CANCELAR</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default InscripcioModal;
